import React, { useRef, useEffect, memo } from 'react';

import { useField } from '@unform/core';
import PropTypes from 'prop-types';

function Input({ name, options, label, ...rest }) {
  const inputRef = useRef(null);

  const { fieldName, defaultValue, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  return (
    <select ref={inputRef} defaultValue={defaultValue} {...rest}>
      <option selected value="">
        Selecionar
      </option>

      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
};

export default memo(Input);
